import React, { useState, useEffect } from 'react'
import axios from 'axios'

const Form3 = () => {
    // [All your existing state declarations remain unchanged]
    
    // [All your existing functions (handleSubmit, shippingCost, etc.) remain unchanged]
    const [name, setName] = useState('')

    useEffect(() => {
        fetch('/api/v1/userProfile')
            .then(res => res.json())
            .then(data => setName(data.user.name))
            .catch(err => console.error(err))
    }, []);

    const [pickupAddress, setPickupAddress] = useState('')
    const [pickupPincode, setPickupPincode] = useState('')
    const [email, setEmail] = useState('')
    const [mobile, setMobile] = useState('')
    const [dname, setDname] = useState('')
    const [dropAddress, setDropAddress] = useState('')
    const [dropPincode, setDropPincode] = useState('')
    const [demail, setDEmail] = useState('')
    const [dmobile, setDMobile] = useState('')
    const [deliveryType, setDeliveryType] = useState('')
    const [weight, setWeight] = useState('')
    const [date, setDate] = useState('')
    const [time, setTime] = useState('')
    // const [payment, setPayment] = useState('')
    const [shipping, setShipping] = useState(0)
    //const [gst, setGst] = useState('')
    const [insurance, setInsurance] = useState('')
    //const [total, setTotal] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(deliveryType)
        await fetch('/api/v1/createDelivery', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
          
            body: JSON.stringify({
                deliveryMode: deliveryType,
                packageWeight: weight,
                pickupLocation: pickupAddress + " Pincode: " + pickupPincode,
                dropLocation: dropAddress + " Pincode: " + dropPincode,
                totalPrice: total,
                deliveryPrice: shipping,
                gst: gst,
                insurance: insurance,
                pickupMob: mobile,
                dateTime: date + " " + time,
                receiverName: dname,
                receiverMob: dmobile
            })
        })
            .then(() => {
                setDEmail("");
                setDMobile("");
                setDate("");
                setDeliveryType("")
                setDname("")
                setDropAddress("")
                setDropPincode("")
                setEmail("")
                setMobile("")
                setName("")
                setPickupAddress("")
                setPickupPincode("")
                setTime("")
                setWeight("")
                //setGst("")
                setInsurance("")
                //setTotal("")
            }).then(res => res.json())
            .then((data) => console.log(data))
            .catch(err => console.error(err))

            console.log(total*100)
            const response = await axios.post("http://localhost:5000/api/v1/payment", {amount:total*100,currency:"INR"}); 
            const {data} = response;
            console.log(data)
            var options = {
                "key": "rzp_test_jcQLiDb23uNp2N", // Enter the Key ID generated from the Dashboard
                "amount": "50000", // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                "currency": "INR",
                "name": "NexisparkX Logistics", //your business name
                "description": "Test Transaction",
                "image": "https://example.com/your_logo",
                "order_id": data.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                "handler": async function (response){
                     const result = await axios.post("http://localhost:5000/api/v1/payment/validate",response);
                     alert(result.data.msg);
                     console.log(result)
                },
                "prefill": { //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
                    "name": "", //your customer's name
                    "email": "", 
                    "contact": "8319251069"  //Provide the customer's phone number for better conversion rates 
                },
                "notes": {
                    "address": "Razorpay Corporate Office"
                },
                "theme": {
                    "color": "#3399cc"
                }
            };
            var rzp1 = new window.Razorpay(options);
            rzp1.on('payment.failed', function (response){
                    alert(response.error.code);
                    alert(response.error.description);
                    alert(response.error.source);
                    alert(response.error.step);
                    alert(response.error.reason);
                    alert(response.error.metadata.order_id);
                    alert(response.error.metadata.payment_id);
            });
            
           const res  = rzp1.open();
      
    }

    // const fetchGeoData = async () => {
    //     try {
    //         const response = await fetch(`https://place-autocomplete1.p.rapidapi.com/autocomplete/json?input=${pickupAddress}&radius=200`, {
    //             method: 'GET',
    //             headers: {
    //                 'X-RapidAPI-Key': 'ca2c4e5d2emshfa30dae8ab6e530p134430jsn422ccf017300',
    //                 'X-RapidAPI-Host': 'place-autocomplete1.p.rapidapi.com'
    //             }
    //         })
    //         const result = await response.text();
    //         console.log(result);
    //     }
    //     catch(e){
    //         console.error(e)
    //     }
    // };
   

    const shippingCost = () => {
        if (deliveryType === 'Within City') {            
            if (weight === 'Upto 1Kg') {
                setShipping(70);
            } else if (weight === 'Upto 5Kg') {
                setShipping(130);
            } else if (weight === 'Upto 10kg') {
                setShipping(210);
            } else if (weight === 'Upto 15Kg') {
                setShipping(280);
            } else if (weight === 'Upto 20Kg') {
                setShipping(380);
            } else {
                setShipping(500);
            }
        }
        else if (deliveryType === 'Intercity') {            
            if (weight === 'Upto 1Kg') {
                setShipping(100);
            } else if (weight === 'Upto 5Kg') {
                setShipping(180);
            } else if (weight === 'Upto 10kg') {
                setShipping(270);
            } else if (weight === 'Upto 15Kg') {
                setShipping(350);
            } else if (weight === 'Upto 20Kg') {
                setShipping(500);
            } else {
                setShipping(700);
            }
        }
    }

    useEffect(()=>{
        shippingCost();        
    },[weight])
    let gst = (shipping*0.18); 
    let total = shipping+gst+15;

    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center p-4">
            <div className="container max-w-4xl mx-auto">
                <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Pickup Details Section */}
                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-100">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                            Pickup Details
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Full Name</label>
                                <input
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-gray-100 text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                />
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Pickup Address</label>
                                <input
                                    value={pickupAddress}
                                    onChange={(e) => setPickupAddress(e.target.value)}
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                />
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Pickup Pincode</label>
                                <input
                                    value={pickupPincode}
                                    onChange={(e) => setPickupPincode(e.target.value)}
                                    placeholder="741201"
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                />
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Mobile Number</label>
                                <input
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                    type="tel"
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Delivery Details Section */}
                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-100">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                            Delivery Details
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Full Name</label>
                                <input
                                    value={dname}
                                    onChange={(e) => setDname(e.target.value)}
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                />
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Drop Address</label>
                                <input
                                    value={dropAddress}
                                    onChange={(e) => setDropAddress(e.target.value)}
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                />
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Drop Pincode</label>
                                <input
                                    value={dropPincode}
                                    onChange={(e) => setDropPincode(e.target.value)}
                                    placeholder="741201"
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                />
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Mobile Number</label>
                                <input
                                    value={dmobile}
                                    onChange={(e) => setDMobile(e.target.value)}
                                    type="tel"
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Order Details Section */}
                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-100">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                            Order Details
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Delivery Type</label>
                                <select
                                    value={deliveryType}
                                    onChange={(e) => setDeliveryType(e.target.value)}
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                >
                                    <option value="">Select Type</option>
                                    <option value="Within City">Within City</option>
                                    <option value="Intercity">Intercity</option>
                                </select>
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Package Weight</label>
                                <select
                                    value={weight}
                                    onChange={(e) => setWeight(e.target.value)}
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                >
                                    <option value="">Select Weight</option>
                                    <option value="Upto 1Kg">1kg</option>
                                    <option value="Upto 5Kg">5kg</option>
                                    <option value="Upto 10kg">10kg</option>
                                    <option value="Upto 15Kg">15kg</option>
                                    <option value="Upto 20Kg">20kg</option>
                                    <option value="More than 20Kg">More than 20kg</option>
                                </select>
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Schedule Date</label>
                                <input
                                    type="date"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                />
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Schedule Time</label>
                                <input
                                    type="time"
                                    value={time}
                                    onChange={(e) => setTime(e.target.value)}
                                    className="w-full p-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Payment Details Section */}
                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-100">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                            Payment Details
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="space-y-4 text-gray-700">
                                <div className="flex justify-between">
                                    <span>Shipping Cost</span>
                                    <span className="font-medium">₹{shipping}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span>GST @18%</span>
                                    <span className="font-medium">₹{(gst).toFixed(2)}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Insurance</span>
                                    <span className="font-medium">₹15.00</span>
                                </div>
                                <div className="flex justify-between pt-2 border-t border-gray-200">
                                    <span className="font-bold">Total</span>
                                    <span className="font-bold text-indigo-600 text-lg">₹{total}</span>
                                </div>
                            </div>
                            <div className="flex items-end">
                                <button
                                    type="submit"
                                    className="w-full py-3 px-6 rounded-lg bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold hover:from-indigo-700 hover:to-purple-700 transition-all shadow-lg hover:shadow-xl"
                                >
                                    Pay Now
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Form3